import { CircleX } from 'lucide-react';
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

type RightSidebarProps = {
  isOpen: boolean;
  onClose: () => void;
  width?: string; // tailwind width class or raw width like '320px'
  footer?: React.ReactNode;
  children?: React.ReactNode;
  showOverlay?: boolean;
  closeOnOverlayClick?: boolean;
  className?:string;
};

export default function RightSidebar({
  isOpen,
  onClose,
  width = 'w-80',
  footer,
  children,
  showOverlay = true,
  closeOnOverlayClick = true,
  className = ""
}: RightSidebarProps) {
  const { pathname } = useLocation()
  useEffect(() => {
    function onKey(e: KeyboardEvent) {
      if (e.key === 'Escape') onClose();
    }
    if (isOpen) window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [isOpen, onClose]);

  const widthClass = width.startsWith('w-') ? width : undefined;
  const rawWidthStyle = widthClass ? undefined : { width } as React.CSSProperties;

  return (
    <>
      {/* Overlay */}
      {/* {isOpen && showOverlay && !isDemo && (
        <div
          className="fixed inset-0 bg-black/40 z-40"
          onClick={() => closeOnOverlayClick && onClose()}
        />
      )} */}

      {/* Sidebar Panel */}

      <div
        className={`absolute inset-y-0 top-0 border border-gray-300 border-r-white right-0 z-50 transform bg-gray-100  flex flex-col h-full transition-transform duration-300 ease-out ${isOpen ? 'translate-x-0' : 'translate-x-full'
          } ${widthClass ?? ''} ${className}`}
        style={rawWidthStyle}
        role="dialog"
      >
        {/* Header */}
        <button
          onClick={onClose}
          className={`p-2 rounded z-10 absolute hover:text-greenBg hover:rotate-180 active:rotate-0 ease-in-out duration-500`}
          aria-label="Close sidebar"
        >
          <CircleX size={20} />
        </button>

        {/* Content */}
        <div className="flex-1  ">{children}</div>

        {/* Footer */}
        {footer && <div className="border-t ">{footer}</div>}
      </div>
    </>
  );
}

